// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"38":"e0c22c71","55":"0207bfc9","151":"f03c7fce","219":"c2b5a2e9","477":"b011ecb5","805":"a9953149"}[chunkId] + ".css";
};